<template>
  <div class=" medicalRecordArea">
    <div class="crumbs">
      <!-- <span><router-link :to="{name:'Transition'}">首页</router-link></span> > -->
       <span>首页</span>>
      <span><router-link :to="{name:'MedicalRecord'}">典型病例库</router-link></span> >
      <span v-if="bread === 'update'">修改病例</span>
      <span v-else>新增病例</span>
    </div>
    <!--病例库-->
    <div class="layout_left_m" >
      <div class="margin10_box medicalRecord_left" ref="leftH">
        <collapse-medical-record v-if="fromShow" style="height:100%;" @tabChange="tabChange" :tabs="tabs" @changeColl="changeColl" :defaultChecked="defaultTreeChecked"
                                 @delPerson="delPerson" @addPersonList="addPersonList" :showCheckBox="true"
                                 @searchClick="searchClick" :personList="personList" :treeData="treeData"
                                 :tabActive="tabActive" :defaultPersonList="defaultPersonListChecked" :catalogSubType="catalogSubType"
                                 @checkTree="checkTree" @personChecked="personChecked" :defaultPersonListChecked="defaultPersonListChecked"
                                 @treeNodeClick="treeNodeClick" :titleList="titleList" :filterText="filterText">
        </collapse-medical-record>
      </div>
    </div>
    <!-- 右侧 -->
    <div class="layout_right_m " v-if="popShow" >
      <div class="layout_right_inner_m ">
        <div class="for_width">
          <div class="margin10_box" style="width: 96%;"  ref="rightH">
            <!--公共-->
            <div :width="width" v-if="fromShow" class="w96">
              <i class="arrow_first">></i>
              <i class="arrow_second">></i>
              <div :width="width" style="position:relative;background: red;top:34px;">
                <el-button v-if="rightTabActive === '1'" class="choose_btn medical_btn" @click="_openScope">从本院影像选择
                </el-button>
              </div>
              <tabs @tabChange="rightTabChange" v-if="fromShow" :activeName="activeName">
                <el-tab-pane v-for="tab in rightTabs" :label="tab.label" :name="tab.name" :key="tab.name" >
                  <div v-show="rightTabActive === '0'" class="tabConHeight">
                    <medical-news ref="medicalNews" v-if="fromShow" @detailUpdate="detailUpdate" :info="detail"  ></medical-news>
                    <div @click="stepMove(1)" class="step_next">下一步</div>
                  </div>
                  <div :width="width" v-show="rightTabActive === '1'" class="tabConHeight">
                    <p-table :head="personTableHead" :height="tableHeiht" :data="studyList"
                             :operation="personTableOperation" :autoheight="autoheight"
                             @_operation="_operation_"></p-table>
                    <div @click="stepMove(-1)" class="step_prev">上一步</div>
                    <div @click="stepMove(1)" class="step_next">下一步</div>
                  </div>
                  <div v-show="rightTabActive === '2'" class="tabConHeight">
                    <upload @fileChange="fileChange" @fileRemove="fileRemove" @fileIsLoading="fileIsLoading" :updateFileList="updateFileList" :updatePicList="updatePicList"></upload>
                    <div @click="stepMove(-1)" class="step_prev">上一步</div>
                  </div>
                </el-tab-pane>
              </tabs>
            </div>
            <!--个人-->
              <buttons v-if="popShow && fromShow" @clickbtn="clickbtn"></buttons>
          </div>
        </div>
      </div>
    </div>
<!--     <div class="button_area">

    </div> -->
    <!--查看-->
    <pops v-if="pop" :show="pop" :width="'1200px'" :title="'从本院影像中选择'" @closePop="closePop" :class="'mrDialog'">
      <pImage @_popshow="_popshow" @_popClose="_popshow" :studyList="studyList"></pImage>
    </pops>
    <div style="position:absolute; top:49%; left: 49%;" v-if="!fromShow">加载中......</div>
    <aycanImages ref="aycanImages" :hospitalId='params_image.hospitalId' :studyPk='params_image.studyPk' :studyUid='params_image.studyUid' ></aycanImages>
  </div>
</template>

<script type="text/ecmascript-6">
import collapse from "@/components/common/collapse/collapse";
import tabs from "@/components/common/tabs/tabs";
import tree from "@/components/common/tree/tree";
import radiusInput from "@/components/common/radiusInput/radiusInput";
import buttons from "@/components/common/button/buttons";
import medicalNews from "@/components/common/medicalNews/medicalNews";
import pTable from "@/components/common/tables/publicTable";
import upload from "@/components/common/upload/uploadFile1";
import pImage from "@/components/common/Image/imageSelection";
import pops from "@/components/common/pops/pop";
import collapseMedicalRecord from "@/components/common/collapseMedicalRecord/collapseMedicalRecord";
import http from "@/api/http";
import * as _ from "@/common/js/config";
import aycanImages from '@/components/common/base/aycanImages'
export default {
  components: {
    collapseMedicalRecord,
    medicalNews,
    buttons,
    radiusInput,
    pTable,
    tree,
    tabs,
    collapse,
    upload,
    pImage,
    pops,
    aycanImages
  },
  watch: {
    attachList(c, o) {
      // if (o.length === 0) {
      //   for (let item of c) {
      //   this.oldAttachList.push(item)
      //   }
      // } else if (c.length > o.length) {
      //   // 添加
      //   for (let item of c) {
      //     for (let i of o) {
      //       if (item.fileid != i.fileid) {
      //         this.oldAttachList.push(item)
      //       }
      //     }
      //   }
      // } else {
      //   // 删除
      // }
      // console.log('ww')
      // console.log(this.oldAttachList)
    },
    studyList() {
      for (let item of this.studyList) {
        if (
          item.patientSex === "F" ||
          item.patientSex === "0" ||
          item.patientSex === "女"
        ) {
          item.caseSex = "女";
        } else {
          item.caseSex = "男";
        }

        if (item.patientAge != undefined) {
          // let ageUnit = {
          //   '1': '天',
          //   '2': '周',
          //   '3': '月',
          //   '4': '岁',
          //   '5': '小时'
          // }
          // item.patientAge =  item.patientAge + ageUnit[item.ageUnit]
        } else {
          item.patientAge = ' '
        }
      }
    }
  },
  data() {
    return {
      detail: {
        ageUnit: '4'
      },
      bread: '',
      autoheight:this.getH(),
      filterText: '',
      catalogId: [],
      studyList: [],
      updateFileList: [],
      updatePicList: [],
      defaultTreeChecked: [],
      defaultPersonListChecked: [],
      personCheckedList: [],
      activeName: '0',
      catalogSubType:'1',
      popShow: true,
      fromShow: true,
      bFileIsLoading: false,
      tableHeiht: 0,
      width: 0,
      pop: false,
      personFlag: 0,
      treeNodeUpload: false,
      personTableHead: [
        {
          props: "hospitalName",
          label: "来源"
        },
        {
          props: "examTypeName",
          label: "类型"
        },
        {
          props: "patientName",
          label: "姓名"
        },
        {
          props: "caseSex",
          label: "性别"
        },
        {
          props: "patientAge",
          label: "年龄"
        },
        {
          props: "examBodyName",
          label: "检查项目"
        }
      ],
      personTableOperation: [
        {
          operation: "",
          class: "icon-yuepian"
        },
        {
          operation: "",
          class: "icon-yichu"
        }
      ],
      rightTabActive: "0",
      personList: [
        { label: "个人病例1" },
        { label: "个人病例2" },
        { label: "个人病例3" }
      ],
      isPerson: false,
      allTreeData: [],
      oldAttachList: [],
      attachList: [],
      treeData: [],
      fileList: [],
      picList: [],
      isCilck: true,
      showCheckBox: true,
      tabs: [
        { label: "公共分类", name: "0" },
        { label: "个人分类", name: "1" }
      ],
      rightTabs: [
        { label: "1.病例信息", name: "0" },
        { label: "2.关联影像", name: "1" },
        { label: "3.添加附件", name: "2" }
      ],
      titleList: [
        { title: "自定义分类", name: "4" },
        { title: "按诊断分类", name: "1" },
        { title: "按部位分类", name: "2" },
        { title: "按科室分类", name: "3" }
      ],
      params_image:{//阅片数据
          hospitalId:'',
          studyPk:'',
          studyUid:'',
        }
    };
  },
  mounted() {
    setTimeout(() => {
      this.layout();
      let [h, el] = [
        document.body.clientHeight ||
          document.getElementById("app").clientHeight,
        document.getElementsByClassName("button_area")[0]
      ];
      // let rH = this.$refs.rightH.offsetHeight
      // console.log(rH)
      //  this.$refs.leftH.style.height = rH + 'px'
      // el.style.height = h - 90 + 'px'
    }, 20);
      window.addEventListener('resize', () => {
        setTimeout(() => {
          this.getH()
        }, 50)
      })
  },
  methods: {
    getH(){
        this.autoheight = document.body.clientHeight - 50 - 40 - 58 - 24  - 78 - 15 //header + crumb + tabs + prev-next  + buttons + marginbuttom
    },
    fileIsLoading(val) {
      this.bFileIsLoading = val;
    },
    _getCaseDetail(id) {
      http.post("/caselib/getCaseDetail.json", { id }).then(res => {
        if (res.data.code === _.ERR_OK) {
          this.fromShow = false;
          this.detail = res.data.model;
          this.aCatalogList = this.detail.catalogList;
          this.catalogSubType = this.detail.catalogList[0].catalogSubType;
          if (this.catalogSubType === "DIANOG") {
            this.catalogSubType = "1";
          } else if (this.catalogSubType === "PART") {
            this.catalogSubType = "2";
          } else if (this.catalogSubType === "DEPT") {
            this.catalogSubType = "3";
          } else {
            this.catalogSubType = "4";
          }
          this.changeColl(this.catalogSubType);
          if (this.detail.attachList.length > 0) {
            for (let item of this.detail.attachList) {
              if (item.attach_type === "file") {
                this.updateFileList.push(item);
              } else {
                this.updatePicList.push(item);
              }
            }
          }
          this.studyList = this.detail.studyList || [];
          this.attachList = this.detail.attachList || [];
          this.oldAttachList = this.detail.attachList || [];
          this.defaultTreeChecked = [];
          this.defaultPersonListChecked = [];
          for (let item of this.detail.catalogList) {
            if (this.tabActive === "1") {
              this.defaultPersonListChecked.push(item.catalogid);
            } else {
              this.defaultTreeChecked.push(item.catalogid);
            }
          }
          this.fromShow = true;
        }
      });
    },
    clickbtn(payload) {
      if (!payload) {
        this.$router.go(-1);
      } else {
        if (!this.isCilck) {
          return false;
        }
        if (this.bFileIsLoading) {
          this.$message({
            message: "文件还在上传中",
            type: "error"
          });
          return false;
        }
        this.isCilck = false;
        if (
          this.detail.caseName === undefined ||
          this.detail.caseSex === undefined
        ) {
          this.$message({
            message: "请填写必填项",
            type: "error"
          });
          this.isCilck = true;
          return false;
        }
        if (this.$route.name.indexOf("update") > -1) {
          // 修改
          let catalogIds = [];
          if (this.catalogId.length > 0) {
            for (let item of this.catalogId) {
              catalogIds.push(item.id);
            }
          } else {
            for (let item of this.aCatalogList) {
              catalogIds.push(item.catalogid);
            }
          }

          for (let item of this.studyList) {
            for (var key in item) {
              if (key !== "hospitalId" && key !== "studyPk") {
                delete item[key];
              }
            }
          }
          let parmars = Object.assign(this.detail, {
            privateType: this.personFlag,
            attachList: this.oldAttachList || [],
            studyList: this.studyList,
            catalogId: !this.treeNodeUpload
              ? this.defaultTreeChecked.join(",")
              : catalogIds.join(",")
          });
          if (!this.isPerson) {
            parmars.catalogId = catalogIds
              .concat(this.defaultTreeChecked.length)
              .join(",");
          } else {
            parmars.catalogId = this.personCheckedList.join(",");
          }
          for (let item of parmars.attachList) {
            for (var key in item) {
              if (
                key !== "fileid" &&
                key !== "attach_name" &&
                key !== "attach_type" &&
                key !== "atatch_size"
              ) {
                delete item[key];
              }
            }
          }
          delete parmars.createDate;
          delete parmars.createDateStr;
          delete parmars.creator;
          delete parmars.creatorName;
          delete parmars.isDelete;
          delete parmars.modifyDate;
          if (parmars.catalogId == "0" || parmars.catalogId == "") {
            alert("请选择要添加到哪个病例库");
            this.isCilck = true;
            return false;
          }
          http
            .post("/caselib/updateCaseInfo.json", parmars)
            .then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$message({
                  type: "info",
                  message: "修改成功"
                });
                this.$router.go(-1);
              }
            })
            .catch(err => {
              alert("提交失败");
              this.isCilck = true;
            });
        } else {
          // 新增
          let catalogIds = [];
          for (let item of this.catalogId) {
            catalogIds.push(item.id);
          }
          for (let item of this.personCheckedList) {
            catalogIds.push(item);
          }
          if (catalogIds.length === 0) {
            alert("请选择要添加到哪个病例库");
            this.isCilck = true;
            return false;
          }
          for (let item of this.studyList) {
            for (var key in item) {
              if (key !== "hospitalId" && key !== "studyPk") {
                delete item[key];
              }
            }
          }
          let parmars = Object.assign(this.detail, {
            privateType: this.personFlag,
            attachList: this.oldAttachList,
            studyList: this.studyList,
            catalogId: catalogIds.join(",")
          });
          http
            .post("/caselib/addCaseInfo.json", parmars)
            .then(res => {
              if (res.data.code === _.ERR_OK) {
                this.$message({
                  type: "info",
                  message: "添加成功"
                });
                this.$router.go(-1);
              } else {
                alert("新增病例失败");
                this.isCilck = true;
              }
            })
            .catch(err => {
              alert(err);
            });
        }
      }
    },
    stepMove(num) {
      this.activeName = (this.activeName - 0 + num).toString();
      this.rightTabActive = (this.rightTabActive - 0 + num).toString();
    },
    _openScope() {
      this.pop = true;
    },
    closePop(payload) {
      this.pop = payload;
    },
    layout() {
      this.tableHeiht = document.getElementById("app").clientHeight - 300;
      let [width, els] = [
        document.getElementById("app").clientWidth - 500 + "px",
        document.getElementsByClassName("for_width")
      ];
      for (let item of els) {
        item.style.width = width;
      }
    },
    tabChange(payload) {
      this.filterText = "";
      this.personList = this.oldPersonList;
      this.personFlag = payload.name;
      this.defaultTreeChecked = [];
      this.defaultPersonListChecked = [];
      this.personCheckedList = [];
      this.catalogId = [];
      if (payload.name === "1") {
        this.isPerson = true;
      } else {
        this.isPerson = false;
      }
    },
    rightTabChange(payload) {
      // console.log(payload);
      this.activeName = payload.name;
      this.rightTabActive = payload.name;
    },
    changeColl(playlod) {
      this.defaultTreeChecked = [];
      this.filterText = "";
      this.treeData = [];
      setTimeout(() => {
        // 1==>部位 2==>诊断 3==>科室
        let [flag, arr] = ["DIANOG", []];
        if (playlod === "1") {
          flag = "DIANOG";
        } else if (playlod === "2") {
          flag = "PART";
        } else if (playlod === "3") {
          flag = "DEPT";
        } else {
          flag = "CUSTOMER";
        }
        this.treeData = [];
        arr = this.allTreeData.filter(item => item.subType === flag);
        for (let item of arr) {
          if (item.parentId === 0) {
            this.treeData.push({
              id: item.id,
              label: item.catalogName,
              children: this.allTreeData.filter(c => c.parentId === item.id)
            });
          }
        }
        for (let item of this.treeData) {
          if (item.children.length > 0) {
            for (let cItem of item.children) {
              cItem.label = cItem.catalogName;
            }
          }
        }
      }, 400);
    },
    treeNodeClick(val) {
      // alert(val)
    },
    _getTreeData(privateType = 0, keyWord = "", subType) {
      let parmars = {
        privateType,
        keyWord,
        subType
      };
      http.post("/catalog/queryCaseCatalogTree.json", parmars).then(res => {
        if (res.data.code === _.ERR_OK) {
          if (privateType === 0) {
            this.allTreeData = res.data.model;
            this.changeColl("1");
          } else {
            this.oldPersonList = res.data.model;
            this.personList = res.data.model;
          }
        }
      });
    },
    addPersonList(val) {
      this.$prompt("请输入病例名", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
        // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        // inputErrorMessage: '邮箱格式不正确'
      })
        .then(({ value }) => {
          let parmars = {
            privateType: "1",
            catalogName: value
          };
          http
            .post("catalog/addCaseCatalog.json", parmars)
            .then(res => {
              if (res.data.code === _.ERR_OK) {
                this._getTreeData(1);
                this.$message({
                  type: "success",
                  message: "提交成功"
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            })
            .catch(err => {
              alert(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    delPerson(val) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      })
        .then(() => {
          let parmars = {
            id: val.id
          };
          http.post("catalog/deleteCaseCatalog.json", parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              this._getTreeData(1);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    searchClick(val) {
      this.filterText = val;
      this.personList = this.oldPersonList.filter(
        item => item.catalogName.indexOf(val) > -1
      );
    },
    checkTree(val) {
      // console.log(val)
      this.treeNodeUpload = true;
      this.catalogId = val;
    },
    detailUpdate(val) {
      // alert(val.name)
      this.detail = val;
    },
    _getPersonTabelData() {
      http.post("edu/qualityImagesList.json", {}).then(res => {
        if (res.data.code === _.ERR_OK) {
          // this.personTableData = res.data.model
        }
      });
    },
    fileChange(val) {
      // console.log("pppp");
      // console.log(val);
      this.oldAttachList = val;
      // console.log(this.oldAttachList);
    },
    fileRemove(val) {
      this.attachList.splice(this.attachList.indexOf(val[val.length - 1]), 1);
    },
    personChecked(val) {
      this.personCheckedList = val;
    },
    _popshow(val) {
      this.pop = false;
      if (val) {
        this.studyList = val;
        // console.log(this.studyList)
      }
    },
    _operation_(val) {
      if (val.operation.indexOf("yichu") > -1) {
        this.$confirm("此操作将移除该条数据是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.studyList.splice(this.studyList.indexOf(val), 1);
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      } else {
        this.params_image.hospitalId = val.hospitalId;
        this.params_image.studyPk = val.studyPk+"";
        this.params_image.studyUid = val.studyUid;
        this.$nextTick(() => {
              this.$refs.aycanImages.getConsultImages();
            })
        // let Aycan = {
        //   hospitalId: val.hospitalId,
        //   studyPk: val.studyPk,
        //   studyUid: val.studyUid
        // };
        // http
        //   .post("/edu/prepareAycan.json", Aycan)
        //   .then(res => {
        //     if (res.data.code === "0000") {
        //       let url = res.data.model;
        //       window.open(url);
        //     } else {
        //       this.$message({
        //         message: "该数据没有影像",
        //         type: "error"
        //       });
        //     }
        //   })
        //   .catch(() => {});
      }
    }
  },
  created() {
    this.getH()
    this._getTreeData();
    this._getTreeData(1);
    this._getPersonTabelData();
    this.tabActive = this.$route.query.flag + "";
    this.personFlag = this.$route.query.flag + "";
    if (this.$route.name.indexOf("update") > -1) {
      this.bread = 'update'
      this._getCaseDetail(this.$route.params.id);
      // this.tabActive = this.$route.query.flag + ''
      this.fromShow = false;
    }
  }
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.w96 {
  width: 96%;
  margin: 0 auto;
}

.medicalRecord {

  overflow: auto;
}

.margin10_box {
  margin: 0 auto;
  background: #fff;
  // height:calc(100vh - 104px);
  overflow-y: auto;
}
.layout_left_m .margin10_box{
  height:calc(100vh - 104px);
}

.layout_left_m {
  float: left;
  width: 300px;
  // min-height: 100%;
  // height: calc(100vh - 118px);
  background: #fff;
}

.layout_right_m {
  float: left;
  width: 100%;
  min-height: 470px;
  margin-left: -300px;
  overflow: hidden;
}

.layout_right_inner_m {
  padding-left: 300px;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.arrow_first {
  position: relative;
  top: 13px;
  left: 80px;
}

.arrow_second {
  position: relative;
  top: 13px;
  left: 174px;
}

.medical_btn {
  background: #00abad;
  padding: 0 20px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  color: #fff;
}

.choose_btn {
  float: right;
  position: absolute;
  top: -43px;
  right: 0px;
  z-index: 100;
}

.person_table {
  .el-table__header {
    height: 36px !important;
  }
}

// .query_detail {
//   width: calc(100% - 180px);
//   height: calc(100% - 50px);
//   position: absolute;
//   // top: 50px;
//   left: 180px;
// }

.step_prev {
  margin-top: 10px;
  cursor: pointer;
  float: left;
}

.step_next {
  margin-top: 10px;
  cursor: pointer;
  float: right;
  margin-right: 1%;
}

.button_area {
  clear: both;
  m;
  margin-top: 20px;
}

.medicalNews,.addFile{
  overflow-y:auto;
  height : calc(100vh - 265px) !important //算法结果同getH()
}
.tabConHeight {
  height: calc(100vh - 239px);
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// newMedicalRecord.vue?16321a25